import { styled } from '@mui/material/styles'
import TableCell from '@mui/material/TableCell'

const StyledTableCell = styled(TableCell)(() => ({
  textAlign: 'right',
  fontWeight: 600,
  width: '20%'
}))

export default StyledTableCell
